
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LoadPredefinedProcedureTemplatesResultDto_$reflection, ProcedureTemplateImportResultDto_$reflection, PredefinedProcedureTemplateDto_$reflection } from "../../Shared/ProcedureTemplateTransfer.js";
import { union_type, class_type, record_type, option_type, string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState_$reflection, ClientApiResponse$1_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { ProcedureTemplateOverviewDto_$reflection } from "../../Shared/Procedure.js";

export class PredefinedDialogState extends Record {
    constructor(Templates, SelectedKey) {
        super();
        this.Templates = Templates;
        this.SelectedKey = SelectedKey;
    }
}

export function PredefinedDialogState_$reflection() {
    return record_type("ProcedureTemplate.Overview.Types.PredefinedDialogState", [], PredefinedDialogState, () => [["Templates", RequestedValue$1_$reflection(list_type(PredefinedProcedureTemplateDto_$reflection()))], ["SelectedKey", option_type(string_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProcedureTemplatesFetched", "ImportFileSelected", "ImportFileRead", "ProcedureTemplateImported", "CloseImportResult", "OpenPredefinedDialog", "PredefinedTemplatesFetched", "SetPredefinedTemplate", "LoadPredefinedTemplates", "PredefinedTemplatesLoaded", "ClosePredefinedDialog", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("ProcedureTemplate.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(ProcedureTemplateOverviewDto_$reflection())]], [["Item", class_type("Browser.Types.File", undefined)]], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(ProcedureTemplateImportResultDto_$reflection())]], [], [], [["Item", list_type(PredefinedProcedureTemplateDto_$reflection())]], [["Item", option_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(LoadPredefinedProcedureTemplatesResultDto_$reflection())]], [], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(ProcedureTemplates, ImportResult, PredefinedDialog, FormState) {
        super();
        this.ProcedureTemplates = ProcedureTemplates;
        this.ImportResult = ImportResult;
        this.PredefinedDialog = PredefinedDialog;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("ProcedureTemplate.Overview.Types.State", [], State, () => [["ProcedureTemplates", RequestedValue$1_$reflection(list_type(ProcedureTemplateOverviewDto_$reflection()))], ["ImportResult", option_type(ProcedureTemplateImportResultDto_$reflection())], ["PredefinedDialog", option_type(PredefinedDialogState_$reflection())], ["FormState", FormState_$reflection()]]);
}

